<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{aLang.nc_title}}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{aLang.nc_title}}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{aLang.nc_title}}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.nc_language" prop="ngon_ngu">
                <el-select
                  v-model="mData.dataForm.ngon_ngu"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode != 'create'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listNgoaiNgu"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item :label="aLang.nc_name" prop="ten">
                <el-input
                  type="text"
                  v-model="mData.dataForm.ten"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.nc_order" prop="thu_tu">
                <el-input
                  type="number"
                  v-model="mData.dataForm.thu_tu"
                  :disabled="mData.viewMode == 'detail'"
                  min="0"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <!-- <b-col md="2" cols="4">
              <el-form-item label=" " prop="noi_bat">
                <el-checkbox
                  v-model="mData.dataForm.noi_bat"
                  :disabled="mData.viewMode == 'detail'"
                >{{aLang.nc_highlights}}</el-checkbox>
              </el-form-item>
            </b-col> -->
            <b-col md="2" cols="4">
              <el-form-item label=" " prop="an">
                <el-checkbox
                  v-model="mData.dataForm.an"
                  :disabled="mData.viewMode == 'detail'"
                >{{aLang.nc_hide}}</el-checkbox>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <!-- <b-col md="3" sm="6">
              <el-form-item class="mb-0" :label="aLang.nc_avatar">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit"
                  :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien"
                  :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien"
                  :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                  :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col> -->
            <b-col md="3" sm="6">
              <el-form-item class="mb-0" :label="aLang.nc_icon">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="picture-card"
                  :limit="mData.fileUploadOption.Icon.limit"
                  :accept="mData.fileUploadOption.Icon.accept"
                  :on-change="fn_uploadChangeIcon"
                  :on-preview="fn_uploadPreviewIcon"
                  :on-remove="fn_uploadRemoveIcon"
                  :on-exceed="fn_uploadExceedIcon"
                  :file-list="mData.fileUploadOption.Icon.fileList"
                  :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.Icon.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.fileUploadOption.Icon.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img width="100%" :src="mData.fileUploadOption.Icon.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DanhMucTinTucModel from "./DanhMucTinTucModel";
import DanhMucTinTucApi from "../../../moduleApi/DanhMucTinTucApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "DanhMucTinTuc",
        dataDefault: {
          roles: DataService.rolesInForm,
          listNgoaiNgu: DataService.Languages
        },
        fileUploadOption: {
          AnhDaiDien: MethodService.copyObject(
            DanhMucTinTucModel.dataFormOther.fileUploadOption.AnhDaiDien
          ),
          Icon: MethodService.copyObject(
            DanhMucTinTucModel.dataFormOther.fileUploadOption.Icon
          ),
        },
        dataForm: MethodService.copyObject(DanhMucTinTucModel.dataForm),
        validForm: DanhMucTinTucModel.validForm,
        dialog: {}
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await DanhMucTinTucApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await DanhMucTinTucApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await DanhMucTinTucApi.findById(id);

      if (res.result && res.result.anh_dai_dien_id) {
        let data = {
          id: res.result.anh_dai_dien_id,
          name: res.result.anh_dai_dien_id,
          url: ExtensionService.urlImg + res.result.anh_dai_dien_id
        };
        this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
      }
      if (res.result && res.result.icon) {
        let data = {
          id: res.result.icon,
          name: res.result.icon,
          url: ExtensionService.urlImg + res.result.icon
        };
        this.mData.fileUploadOption.Icon.fileList.push(data);
      }

      this.mData.dataForm = res.result;
      console.log("this.mData.dataForm",this.mData.dataForm);
    },
    async fn_initDataDefault() {},

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_uploadRemoveAnhDaiDien(file, fileList) {
      this.mData.dataForm.anh_dai_dien_id = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "tinTuc")
        .then(res => {
          this.mData.dataForm.anh_dai_dien_id = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien(files, fileList) {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {

      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    fn_uploadRemoveIcon(file, fileList) {
      this.mData.dataForm.icon = null;
      this.mData.fileUploadOption.Icon.fileList = [];
    },
    fn_uploadChangeIcon(file, fileList) {
      ExtensionService.upload(file, "iconTinTuc")
        .then(res => {
          this.mData.dataForm.icon = res.result;
          this.mData.fileUploadOption.Icon.fileList = fileList;
        })
        .catch(error => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedIcon(files, fileList) {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.Icon.limit} file`
      );
    },
    fn_uploadPreviewIcon(file) {
      this.mData.fileUploadOption.Icon.dialogImageUrl = file.url;
      this.mData.fileUploadOption.Icon.dialogVisible = true;
    }
  },
  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>